import React, { useState, useEffect } from "react";
import axios from "axios";

const SubirCatalogoReducido = () => {
  const [file, setFile] = useState(null);
  const [sucursal, setSucursal] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");

  const [sucursalesDisponibles, setSucursalesDisponibles] = useState([]);
  const [sucursalExportar, setSucursalExportar] = useState("");
  const [exportando, setExportando] = useState(false);
  const [errorExportar, setErrorExportar] = useState("");

  const cargarSucursales = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/des/sucursales-con-catalogo`
      );
      setSucursalesDisponibles(res.data);
    } catch (err) {
      console.error("Error cargando sucursales:", err);
    }
  };

  useEffect(() => {
    cargarSucursales();
  }, []);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async () => {
    if (!file || !sucursal) {
      setError("Todos los campos son obligatorios.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("sucursal", sucursal.trim());

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/des/catalogoreducido`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setMensaje(res.data.message + ` (${res.data.productos_cargados} productos)`);
      setError("");
      cargarSucursales();
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.detail || "Error al subir el archivo.");
      setMensaje("");
    }
  };

  const handleExportar = async () => {
    if (!sucursalExportar) {
      setErrorExportar("Selecciona una sucursal.");
      return;
    }

    setExportando(true);
    setErrorExportar("");

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/des/exportar/${sucursalExportar}`,
        { responseType: "blob" }
      );

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `catalogo_reducido_${sucursalExportar}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      setErrorExportar("Error al exportar el catálogo.");
    } finally {
      setExportando(false);
    }
  };

  const cardStyle = {
    maxWidth: 400,
    margin: "20px auto",
    padding: 30,
    borderRadius: 12,
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    backgroundColor: "#fff",
    textAlign: "center",
    fontFamily: "Arial, sans-serif"
  };

  const inputStyle = {
    width: "100%",
    padding: 10,
    marginBottom: 12,
    borderRadius: 6,
    border: "1px solid #ccc",
    display: "block",
    boxSizing: "border-box"
  };

  const buttonStyle = {
    border: "none",
    padding: "10px 20px",
    borderRadius: 6,
    cursor: "pointer",
    display: "block",
    width: "100%",
    fontSize: "0.9em",
    fontWeight: "bold",
    color: "white"
  };

  return (
    <div>
      <div style={cardStyle}>
        <h2 style={{ marginBottom: 20 }}>Subir Catálogo Reducido</h2>

        <input
          type="text"
          value={sucursal}
          onChange={(e) => setSucursal(e.target.value)}
          placeholder="Ej: 180"
          style={inputStyle}
        />

        <input
          type="file"
          accept=".xlsx"
          onChange={handleFileChange}
          style={{ marginBottom: 15, fontSize: "0.9em", display: "block", width: "100%" }}
        />

        <button
          onClick={handleSubmit}
          style={{ ...buttonStyle, backgroundColor: "#007B8F" }}
        >
          Subir Catálogo
        </button>

        {mensaje && <p style={{ color: "green", marginTop: 15 }}>{mensaje}</p>}
        {error && <p style={{ color: "red", marginTop: 15 }}>{error}</p>}
      </div>

      <div style={cardStyle}>
        <h2 style={{ marginBottom: 20 }}>Exportar Catálogo Reducido</h2>

        <select
          value={sucursalExportar}
          onChange={(e) => setSucursalExportar(e.target.value)}
          style={inputStyle}
        >
          <option value="">Seleccionar sucursal...</option>
          {sucursalesDisponibles.map((s) => (
            <option key={s.sucursal} value={s.sucursal}>
              Sucursal {s.sucursal}
            </option>
          ))}
        </select>

        <button
          onClick={handleExportar}
          disabled={exportando}
          style={{
            ...buttonStyle,
            backgroundColor: exportando ? "#aaa" : "#2E7D32",
            cursor: exportando ? "not-allowed" : "pointer"
          }}
        >
          {exportando ? "Exportando..." : "Descargar Catálogo"}
        </button>

        {errorExportar && <p style={{ color: "red", marginTop: 15 }}>{errorExportar}</p>}
      </div>
    </div>
  );
};

export default SubirCatalogoReducido;
